// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"312a8f1b","225":"f81a8a8a","358":"9b3251c2","611":"21dce785","639":"a9816f56","652":"9009a9e8","659":"38427137","853":"8821e1b6","948":"b82a094b"}[chunkId] + ".chunk.js";
};